import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { BaseComponent } from '../../../BaseComponent';
import { getSirvImgUrlExterior, getImgUrlExterior } from '../../../../modules/Vehicles/helpers';
import { selectWorks } from '../../../../modules/Api/selectors';
import {
  REQUEST_VEHICLE_DOCUMENTS_BY_TYPE,
  REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
} from '../../../../modules/Vehicles/constants';
import { getDocumentsByType } from '../../../../modules/Vehicles/actions';
import { Loader } from '../../../Loader';
import cn from 'classnames';
import { selectVehicleDocs } from '../../../../modules/Vehicles/selectors';

const Container = styled.div`
  min-width: 150px;
  max-width: 150px;
  min-height: 50px;
  margin: 6px;

  .avatarImg {
    max-width: 100%;
    height: auto;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    width: 300px;
    height: 160px;
  }
  @media (max-width: 450px) {
    width: 150px;
    height: 80px;
  }

  position: relative;

  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 150px;
    height: 85px;
    margin-top: -30px;
    margin-bottom: -20px;
    clip-path: inset(15px 0 0 0);
  }
`;

const STATE = {};

class VehicleAvatarComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.autoLoadPhotos) {
      this.props.getPhotos(result => {
        if (result?.length && result[0]?.id) {
          this.setState({ leftFrontImage: result[0] });
        }
      });
    }
  }

  render() {
    const { props } = this;
    if (this.props.work || (!this.props.photos && !this.props.autoLoadPhotos)) return <Loader small />;

    const leftFrontImage = this.state.leftFrontImage || this.props.photos?.[0];
    if (leftFrontImage?.id) {
      return (
        <>
          <Container className="avatar" vehicle={props.vehicle} onClick={props.onClick}>
            <div
              className="img bottom"
              style={{
                backgroundImage: `url('${encodeURI(decodeURI(leftFrontImage?.url)).replace(/%5C/g, '/')}')`,
              }}
            ></div>
          </Container>
        </>
      );
    }

    return (
      <>
        <Container className={cn('avatar', props.className)} vehicle={props.vehicle} onClick={props.onClick}>
          <div
            className={cn('img', 'bottom', props.className)}
            style={{
              backgroundImage: `${
                props.vehicle?.action_ws2_interior_inspection_done === '1'
                  ? `url('${encodeURI(
                      decodeURI(getImgUrlExterior(props.vehicle?.helga_id || props.vehicle?.id, '01')),
                    ).replace(/%5C/g, '/')}')`
                  : `url('/public/images/placeholder.png')`
              }`,
            }}
          ></div>
        </Container>
      </>
    );
  }
}

VehicleAvatarComp.propTypes = {
  autoLoadPhotos: PropTypes.bool,
};
VehicleAvatarComp.defaultProps = {
  autoLoadPhotos: true,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${ownProps.vehicle?.id}`]),
    photos: selectVehicleDocs(ownProps.vehicle?.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    getPhotos(callback) {
      dispatch(getDocumentsByType(ownProps.vehicle?.id, 'photo_interior_general_0left_front', callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleAvatar = compose(withConnect, withRouter)(VehicleAvatarComp);
